import type { UsageTotals } from "../lib/aggregate";
import { formatTokens, formatUsd, formatMinutes } from "../lib/format";
import { Coins, Lightning, Microphone, Stack } from "@phosphor-icons/react";
import { Card } from "@/components/ui/card";

interface Props {
  totals: UsageTotals;
}

export function UsageHeaderCards({ totals }: Props) {
  const items = [
    {
      label: "Custo total",
      value: formatUsd(totals.costUsd),
      sub: `${totals.callCount.toLocaleString("pt-BR")} chamadas`,
      icon: Coins,
    },
    {
      label: "Tokens",
      value: formatTokens(totals.totalTokens),
      sub: `${formatTokens(totals.inputTokens)} in / ${formatTokens(totals.outputTokens)} out`,
      icon: Stack,
    },
    {
      label: "Áudio",
      value: formatMinutes(totals.audioSeconds),
      sub: "transcrito",
      icon: Microphone,
    },
    {
      label: "Média/chamada",
      value:
        totals.callCount > 0
          ? formatUsd(totals.costUsd / totals.callCount)
          : "$0.00",
      sub:
        totals.callCount > 0
          ? `${formatTokens(Math.round(totals.totalTokens / totals.callCount))} tokens/call`
          : "—",
      icon: Lightning,
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {items.map(({ label, value, sub, icon: Icon }) => (
        <Card
          key={label}
          className="p-4 flex items-start gap-3 bg-card/70 hover:bg-card transition-colors"
        >
          <div className="rounded-lg bg-primary/10 p-2 text-primary">
            <Icon weight="duotone" className="h-5 w-5" aria-hidden="true" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">
              {label}
            </p>
            <p
              className="text-xl font-semibold text-foreground tracking-tight truncate"
              style={{ fontVariantNumeric: "tabular-nums" }}
            >
              {value}
            </p>
            <p className="text-xs text-muted-foreground truncate">{sub}</p>
          </div>
        </Card>
      ))}
    </div>
  );
}
